import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

interface UseIntersectionObserverProps {
  threshold?: number;
  triggerOnce?: boolean;
  rootMargin?: string;
}

export const useIntersectionObserver = ({
  threshold = 0.1,
  triggerOnce = true,
  rootMargin = '-50px'
}: UseIntersectionObserverProps = {}) => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const { ref, inView } = useInView({
    threshold,
    triggerOnce,
    rootMargin
  });

  useEffect(() => {
    if (inView && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [inView, hasAnimated]);

  return {
    ref,
    isVisible: inView || hasAnimated,
    hasAnimated
  };
};
